import React, { Component } from 'react';
import SelectCliente from '../components/Cliente/SelectCliente'
/**
 * Used for the Listino Prezzi section. 
 */
export class Clienti1 extends Component {

    constructor(props) {
        super(props);

        this.state = {
            clienti: [],
            searchClienti: [],
            searchCodiceClienti: [],
            searchComplete: false,
            searchCodiceComplete: false,
        };
    
    }

    
    /**
     * Runs upon initial mount of the /listinoPrezzi path
     */
    componentDidMount(){
        
        const form = {
            Informazione: "",
            CurrentRole: this.props.role
        };

        fetch(`../api/clienti/cerca`, {   
            method: 'POST',
            headers: new Headers({
                //Authorization token
                'Authorization': 'Bearer ' + sessionStorage.getItem("auth"),
                //Sets the content type. Necessary for the server to recognize the information
                'Content-Type': 'application/json' 
            }),
            //Sets the body of the call
            body: JSON.stringify(form)
            //Changes the response to an object
        }).then(response => response.json())
        .then(myjson => {
            this.setState({
                clienti: myjson
            })

        }).catch(e => {

        });
    }    

    clienteSelected = (cliente) => {
        console.log(cliente)
        this.props.history.push(`/clienti/view/${cliente.codiceCliente}`)
    }

    clienteSearch = (text) => {
        console.log(text);
        if(!text){
            this.setState({
                searchClienti: [],
                searchComplete: false
            })
        }
        else{
            const form = {
                Informazione: text,
                CurrentRole: sessionStorage.getItem("selectedRole")
            };
    
            fetch(`../api/clienti/cerca`, {   
                method: 'POST',
                headers: new Headers({
                    //Authorization token
                    'Authorization': 'Bearer ' + sessionStorage.getItem("auth"),
                    //Sets the content type. Necessary for the server to recognize the information
                    'Content-Type': 'application/json' 
                }),
                //Sets the body of the call
                body: JSON.stringify(form)
                //Changes the response to an object
            }).then(response => response.json())
            .then(myjson => {
                this.setState({
                    searchClienti: myjson,
                    searchComplete: true,
                })
    
            }).catch(e => {
    
            });
        }
    } 

    clienteCodiceSearch = (text) => {
        console.log(text);
        if(!text){
            this.setState({
                searchCodiceClienti: [],
                searchCodiceComplete: false
            })
        }
        else{
            const form = {
                Informazione: text,
                CurrentRole: sessionStorage.getItem("selectedRole")
            };
            console.log(form)
            fetch(`../api/clienti/cercaCodice`, {   
                method: 'POST',
                headers: new Headers({
                    //Authorization token
                    'Authorization': 'Bearer ' + sessionStorage.getItem("auth"),
                    //Sets the content type. Necessary for the server to recognize the information
                    'Content-Type': 'application/json' 
                }),
                //Sets the body of the call
                body: JSON.stringify(form)
                //Changes the response to an object
            }).then(response => response.json())
            .then(myjson => {
                this.setState({
                    searchCodiceClienti: myjson,
                    searchCodiceComplete: true,
                })
    
            }).catch(e => {
    
            });
        }
    } 

    /**
     * Renders the page
     */
    render() {

        return (
            <SelectCliente 
                clienti={this.state.clienti}
                searchClienti={this.state.searchClienti}
                searchCodiceClienti={this.state.searchCodiceClienti}
                searchComplete={this.state.searchComplete}
                searchCodiceComplete={this.state.searchCodiceComplete}
                clienteSelected={this.clienteSelected}
                clienteSearch={this.clienteSearch}
                clienteCodiceSearch={this.clienteCodiceSearch}
            />
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/Clienti1.js